module.exports = __webpack_public_path__ + "static/media/newsfetch-io.e82911eb.png";